import { render, staticRenderFns } from "./GuijiHistory.vue?vue&type=template&id=706c3960&scoped=true&"
import script from "./GuijiHistory.vue?vue&type=script&lang=js&"
export * from "./GuijiHistory.vue?vue&type=script&lang=js&"
import style0 from "./GuijiHistory.vue?vue&type=style&index=0&id=706c3960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c3960",
  null
  
)

export default component.exports